import { CompositeDecorator } from "draft-js";

import { Link } from "./Link";
import { StyledText } from "./StyledText";

const decorators = new CompositeDecorator([
    {
        strategy: createStyleStrategy(["color", "bgcolor"]),
        component: StyledText
    },
    {
        strategy: createTypeStrategy("LINK"),
        component: Link
    }
]);


/**
 * Create type strategy for decorator
 * @param type
 * @returns {function(*, *=, *)}
 */
 function createTypeStrategy(type) {
    return (contentBlock, callback, contentState) => {
        contentBlock.findEntityRanges((character) => {
            const entityKey = character.getEntity();
            return entityKey !== null && contentState.getEntity(entityKey).getType() === type;
        }, callback);
    };
}


function createStyleStrategy(styles) {
    return (contentBlock, callback, contentState) => {
        contentBlock.findStyleRanges((character) => {
            return character.getStyle().size > 0;
        }, callback);
    };
}

export default decorators;
